import axios from "axios";
import { toast } from "react-toastify";


const merchantAxiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json"
  },
});

merchantAxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 500) {
      toast.error("Something went wrong", { position: "top-right", autoClose: 3000 });
    }
    return Promise.reject(error);
  }
);

export default merchantAxiosInstance;
